import { Component } from '@angular/core';

@Component({
  selector: 'app-recuperar-acesso',
  imports: [],
  templateUrl: './recuperar-acesso.component.html',
  styleUrl: './recuperar-acesso.component.css'
})
export class RecuperarAcessoComponent {

}
